import React, { useState, useEffect, useCallback } from "react";
import {
  Container, Paper, Typography, Button, TextField, Table, TableBody, TableCell,
  TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions, MenuItem, Switch, FormControlLabel, Chip, makeStyles
} from "@material-ui/core";
import { Add, Edit, Delete } from "@material-ui/icons";
import { getTicketCustomFields, createTicketCustomField, updateTicketCustomField, deleteTicketCustomField } from "../../services/api.new-features";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },
  paper: { padding: theme.spacing(2), marginTop: theme.spacing(2) },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center" },
}));

const fieldTypes = [
  { value: "text", label: "Texto" },
  { value: "number", label: "Número" },
  { value: "date", label: "Data" },
  { value: "select", label: "Seleção" },
  { value: "checkbox", label: "Checkbox" },
];

const TicketCustomFields = () => {
  const classes = useStyles();
  const [fields, setFields] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [current, setCurrent] = useState({});

  const load = useCallback(async () => {
    try {
      const res = await getTicketCustomFields();
      setFields(res.data);
    } catch (e) { toast.error("Erro ao carregar campos"); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSave = async () => {
    try {
      const data = { ...current };
      if (data.type === "select" && typeof data.options === "string") {
        data.options = data.options.split(",").map(o => o.trim());
      }
      if (current.id) { await updateTicketCustomField(current.id, data); }
      else { await createTicketCustomField(data); }
      setDialog(false); setCurrent({}); load();
      toast.success("Campo salvo!");
    } catch (e) { toast.error("Erro ao salvar"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Excluir campo?")) return;
    try { await deleteTicketCustomField(id); load(); } catch (e) { toast.error("Erro"); }
  };

  return (
    <Container maxWidth="lg" className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h5">Campos Personalizados - Tickets</Typography>
        <Button variant="contained" color="primary" startIcon={<Add />}
          onClick={() => { setCurrent({ type: "text", required: false }); setDialog(true); }}>
          Novo Campo</Button>
      </div>

      <Paper className={classes.paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Obrigatório</TableCell>
              <TableCell>Ordem</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fields.map(f => (
              <TableRow key={f.id}>
                <TableCell>{f.name}</TableCell>
                <TableCell><Chip size="small" label={fieldTypes.find(t => t.value === f.type)?.label || f.type} /></TableCell>
                <TableCell>{f.required ? "Sim" : "Não"}</TableCell>
                <TableCell>{f.order}</TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => { setCurrent(f); setDialog(true); }}><Edit /></IconButton>
                  <IconButton size="small" onClick={() => handleDelete(f.id)}><Delete /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={dialog} onClose={() => setDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{current.id ? "Editar Campo" : "Novo Campo"}</DialogTitle>
        <DialogContent>
          <TextField fullWidth margin="dense" label="Nome" value={current.name || ""}
            onChange={e => setCurrent({ ...current, name: e.target.value })} />
          <TextField fullWidth margin="dense" label="Tipo" select value={current.type || "text"}
            onChange={e => setCurrent({ ...current, type: e.target.value })}>
            {fieldTypes.map(t => <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>)}
          </TextField>
          {current.type === "select" && (
            <TextField fullWidth margin="dense" label="Opções (separadas por vírgula)"
              value={Array.isArray(current.options) ? current.options.join(", ") : current.options || ""}
              onChange={e => setCurrent({ ...current, options: e.target.value })} />
          )}
          <TextField fullWidth margin="dense" label="Ordem" type="number" value={current.order || 0}
            onChange={e => setCurrent({ ...current, order: Number(e.target.value) })} />
          <FormControlLabel control={
            <Switch checked={!!current.required} onChange={e => setCurrent({ ...current, required: e.target.checked })} />
          } label="Obrigatório" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog(false)}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained" color="primary">Salvar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TicketCustomFields;